import React from "react";

const OsmosisDataSkeleton = () => {
  return (
    <div className="mb-8">
      <h3 className="text-2xl font-semibold mb-4 animate-pulse text-gray-200 bg-gray-200 rounded-md h-8 text-center">
        Osmosis Pool 1721
      </h3>
      <div className="mb-8 p-4 bg-white shadow rounded-lg">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-center">
          <div>
            <h3 className="text-lg text-gray-200 animate-pulse bg-gray-200 rounded-md h-6 mx-auto">
              Liquidity
            </h3>
            <p className="text-xl font-bold text-gray-200 animate-pulse bg-gray-200 rounded-md h-8 mx-auto mt-2"></p>
          </div>
          <div>
            <h3 className="text-lg text-gray-200 animate-pulse bg-gray-200 rounded-md h-6 mx-auto">
              Pooled wLibra
            </h3>
            <p className="text-xl font-bold text-gray-200 animate-pulse bg-gray-200 rounded-md h-8 mx-auto mt-2"></p>
          </div>
          <div>
            <h3 className="text-lg text-gray-200 animate-pulse bg-gray-200 rounded-md h-6 mx-auto">
              Pooled USDC
            </h3>
            <p className="text-xl font-bold text-gray-200 animate-pulse bg-gray-200 rounded-md h-8 mx-auto mt-2"></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OsmosisDataSkeleton;
